import { useCreateAddToProject } from 'api-hooks/sale/add-to-project/mutation';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ROLE,
  SIZE,
} from 'baseui/modal';
import notification from 'components/common/notification';
import { Form, Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import ProjectListSelectInput from 'legacy-modules/projects/component/select-input';
import { DialogCommonStyles, SeparatorHorizontal } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useForm } from 'react-hook-form';

interface Props {
  saleId: string;
  onClose: () => void;
}

type FormType = {
  projectId: string | null;
};

export default function AddToProjectModal(props: Props) {
  const { t } = useTranslation();
  const { saleId, onClose } = props;

  const { mutateAsync } = useCreateAddToProject();

  const methods = useForm<FormType>({
    defaultValues: {
      projectId: null,
    },
    mode: 'onChange',
  });

  const onSubmit = React.useCallback(
    async (values: FormType) => {
      try {
        const result = await mutateAsync({
          saleId,
          projectId: values.projectId,
        });
        notification.success({ message: result.message });
        onClose();
      } catch (error) {
        notification.error({ message: error?.message });
      }
    },
    [mutateAsync, onClose, saleId],
  );

  return (
    <Modal
      closeable={false}
      isOpen
      animate
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus
      size={SIZE.default}
      role={ROLE.dialog}
      overrides={DialogCommonStyles}
    >
      <ModalHeader>{t('common:add_to_project')}</ModalHeader>
      <Form methods={methods} onSubmit={onSubmit}>
        <ModalBody>
          <ProjectListSelectInput name="projectId" />
        </ModalBody>
        <ModalFooter $style={{ display: 'flex', justifyContent: 'end' }}>
          <Button buttonType="tertiary" onClick={onClose}>
            {t('common:cancel')}
          </Button>
          <SeparatorHorizontal $margin={8} />
          <Input type="submit" />
        </ModalFooter>
      </Form>
    </Modal>
  );
}
